import type { MailerConfigsListRow } from "@/admin/entities/mailerConfigs";
import type { MailerConfigsListQueryType } from "@/types/graphql/admin.generated";

export function getTableData(data: unknown): {
  nodes: MailerConfigsListRow[];
  count: number;
} {
  const list = (data as MailerConfigsListQueryType)?.mailerConfigs;

  if (!list?.nodes) {
    return { nodes: [], count: 0 };
  }

  return list;
}

export function mapColumns(row: MailerConfigsListRow) {
  return [row.id, row, row.from, row.siteUrl, row.siteName, row.createdAt];
}
